import { Alert, Collapse, IconButton } from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

interface ConfirmInfoProps {
  text: string;
  keyId: string;
}

const ConfirmInfo = (props: ConfirmInfoProps) => {
  const { text, keyId } = props;
  const k = `Info_${keyId}`;
  const [open, setOpen] = useState<boolean>(
    localStorage.getItem(k) !== "true" || localStorage.getItem(k) === null
  );

  return (
    <Collapse in={open}>
      <Alert
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              setOpen(false);
              localStorage.setItem(k, "true");
            }}
          >
            <CloseIcon fontSize="inherit" titleAccess="Close this tip." />
          </IconButton>
        }
        sx={{ mb: 2 }}
      >
        {text}
      </Alert>
    </Collapse>
  );
};

export default ConfirmInfo;
